<template>
	<v-card :width="displayResponsive ? '100%' : '20em'" color="contained" rounded="xl" style="margin: 0 auto" @click="click">
		<v-layout>
			<div>
				<v-card-title>
					{{ domain?.name }}
				</v-card-title>
				<v-card-subtitle>
					{{ domain?.description }}
				</v-card-subtitle>
			</div>
		</v-layout>
		<v-card-text>
			<v-chip v-if="domain?.members" class="ma-1">
				{{ domain?.members.length }}
				{{ symbolsStore.GUILabel("12afad78-3062-4760-abac-e6637f270a1b") }}
			</v-chip>
		</v-card-text>
	</v-card>
</template>

<script setup lang="ts">
import type { Domain, User } from "@lr-notitia/notitia-operator/schemas";
import { onMounted, ref } from "vue";
import { api } from "@lr-notitia/notitia-operator/client";
import { useSymbolsStore } from "../store/symbols";
import { useResponsiveLayout } from "@lr-notitia/notitia-ui";

const symbolsStore = useSymbolsStore();

const { displayResponsive } = useResponsiveLayout()

const domain = ref<Domain>();
const account = ref<User>();

const compProps = defineProps({
	domainId: {
		type: String,
		required: true,
	},
});

const emits = defineEmits(["click"]);

function click() {
	emits("click", compProps.domainId);
}

onMounted(() => {
	loadDomain();
	loadAccount();
});

function loadDomain() {
	api()
		.domain(compProps.domainId)
		.get()
		.then((data) => {
			domain.value = data;
		})
		.catch((err) => {
			// TODO implement error handling
			console.error(err);
		});
}

function loadAccount() {
	api()
		.domain(compProps.domainId)
		.account()
		.get()
		.then((data) => {
			account.value = data;
		})
		.catch((err) => {
			// TODO implement error handling
			console.error(err);
		});
}
</script>

<style scoped lang="scss"></style>
